<template>
	<div class="footer">
      <div class="content">
           <div class="content-main">

              <div class="content-main-bar">
                <span @click="clickBar(0)">首页</span>
                <span @click="clickBar(1)">关于我们</span>
                <span @click="clickBar(2)">产品&解决方案与服务</span>
                <span @click="clickBar(3)">经典案例</span>
                <span @click="clickBar(4)">新闻中心</span>
                <span @click="clickBar(5)">加入我们</span>
                <span @click="clickBar(6)">联系我们</span>
              </div>

<!--              <div class="link-us">-->
<!--                <span @click="clickBar(6)" style="cursor: pointer;">联系我们</span>-->
<!--              </div>-->
              <div class="city">
                 <div class="city-name">
                   <span @click="clickCity(0)">北京总部</span>
                   <div class="city_undeline" v-if="nowCity==0"></div>
                 </div>
                <div class="city-name">
                  <span @click="clickCity(1)">深圳</span>
                  <div class="city_undeline" v-if="nowCity==1"></div>
                </div>
                <div class="city-name">
                  <span @click="clickCity(2)">上海</span>
                  <div class="city_undeline" v-if="nowCity==2"></div>
                </div>
                <div class="city-name">
                  <span @click="clickCity(7)">广州</span>
                  <div class="city_undeline" v-if="nowCity==7"></div>
                </div>
                <div class="city-name">
                  <span @click="clickCity(6)">成都</span>
                  <div class="city_undeline" v-if="nowCity==6"></div>
                </div>
                <div class="city-name">
                  <span @click="clickCity(5)">武汉</span>
                  <div class="city_undeline" v-if="nowCity==5"></div>
                </div>
                <div class="city-name">
                  <span @click="clickCity(4)">长沙</span>
                  <div class="city_undeline" v-if="nowCity==4"></div>
                </div>
                <div class="city-name">
                  <span @click="clickCity(9)">沈阳</span>
                  <div class="city_undeline" v-if="nowCity==9"></div>
                </div>
                <div class="city-name">
                  <span @click="clickCity(8)">郑州</span>
                  <div class="city_undeline" v-if="nowCity==8"></div>
                </div>
                <div class="city-name">
                  <span @click="clickCity(3)">石家庄</span>
                  <div class="city_undeline" v-if="nowCity==3"></div>
                </div>
                <div class="city-name">
                  <span @click="clickCity(10)">佛山</span>
                  <div class="city_undeline" v-if="nowCity==10"></div>
                </div>
                <div class="city-name">
                  <span @click="clickCity(11)">西安</span>
                  <div class="city_undeline" v-if="nowCity==11"></div>
                </div>
              </div>

              <div class="link-message">
                <div>
                  <span v-text="'地址:'+nowCompany.address"></span>
                </div>
<!--                <div>-->
<!--                  <span v-text="'邮政:'+nowCompany.postal"></span>-->
<!--                </div>-->
                <div>
                  <span v-show="nowCompany.phone" v-text="'电话:'+nowCompany.phone"></span>
                </div>
              </div>

           </div>

           <div class="about-us">
                <span>关注我们</span>
                <el-image :src="imageURL"></el-image>
           </div>
      </div>
      <div class="company">
          <div>
             <a target="_blank" href="https://beian.miit.gov.cn/">ICP备案： 京ICP备13018112号</a><span>copyright @ 2018 - 2020 北京开科唯识技术股份有限公司</span>
          </div>
<!--          <span>ICP备案： 京ICP备13018112号 copyright @ 2018 - 2020 北京开科唯识技术股份有限公司</span>-->
      </div>
      <div  class="zd" id="zd" >
        <el-image @click="clickZd" :src="zd"></el-image>
      </div>
  </div>
</template>
<script>
	export default {
	  data(){
	    return{
        zd:require('../../assets/img/zdy.png'),
	      imageURL:require('../../assets/img/gzwm.png'),
        company:[{
          name:"北京",
          address:"北京·海淀区北四环西路68号左岸工社5层519",
          phone:"010-82664312",
          postal:"100000"
        },
          {
            name:"深圳",
            address:"广东·深圳·南山区（科技南八路2号豪威科技大厦11层1108）",
            phone:"0755-26426409",
            postal:"11183"
          },
          {
            name:"上海",
            address:"上海·浦东新区（福山路33号建工大厦22D）",
            phone:"",
            postal:"11183"
          },
          {
            name:"石家庄",
            address:"河北·石家庄·桥西区（建设南大街150号囯富大厦1509）",
            phone:"17733292360",
            postal:"11183"
          },
          {
            name:"长沙",
            address:"湖南·长沙·天心区（蓝湾国际B座25楼）",
            phone:"19976955773",
            postal:"11183"
          },
          {
            name:"武汉",
            address:"湖北·武汉·洪山区（文化大道555号融创智谷二期B1栋11层10室）",
            phone:"027-88222749",
            postal:"11183"
          },
          {
            name:"成都",
            address:"四川·成都·高新区（蜀锦路88号楚峰国际中心1306A）",
            phone:"028-85212022",
            postal:"11183"
          },
          {
            name:"广州",
            address:"广东·广州·天河区（体育东路116路3501自编号 -1B22）",
            phone:"0755-26426409",
            postal:"11183"
          },
          {
            name:"郑州",
            address:"河南·郑州·郑东新区（商务外环路13号绿地峰会天下1207号）",
            phone:"13071067710",
            postal:"11183"
          },
          {
            name:"沈阳",
            address:"辽宁·沈阳·沈河区（惠工街10号卓越大厦3层01-10）",
            phone:"",
            postal:"11183"
          },
          {
            name:"佛山",
            address:"广东·佛山·南海区（九江镇龙高公路敦上大道2号三楼3103室）",
            phone:"",
            postal:""
          },
          {
            name:"西安",
            address:"陕西·西安·高新区（天谷八路156号软件新城云汇谷B2座）",
            phone:"",
            postal:""
          },
        ],
        nowCompany:{
          name:"北京",
          address:"北京·海淀区北四环西路68号左岸工社5层519",
          phone:"010-82664312",
          postal:"100000"
        },
        nowCity:0
      }

    },
    mounted() {
      this.$nextTick(()=>{
        var hash = window.location.hash;
        var index = hash.lastIndexOf("#");
        if (index != -1) {
          var id = hash.substring(index + 1, hash.length + 1);
          var div = document.getElementById(id);
          if (div) {
            setTimeout(()=>{
              var top=div.offsetTop
              $('html, body').animate({scrollTop: $(div).offset().top - 80}, 500)
            },500)
          }
        }
      })
    },
    methods:{
      clickZd(){
        document.body.scrollIntoView()
      },
	    clickCity(num){
          this.nowCity=num;
          if(this.company[num].address){
            this.nowCompany=this.company[num]
          }

      },
      clickBar(num){
        localStorage.setItem("top","true")
	      if(num==0){
          this.$router.push({
            path:"/main/desktop"
          })
        }else if(num==1){
          localStorage.setItem("xl","secondaryMenu")
          this.$router.push({
            path:"/main/aboutUs"
          })
        }else if(num==4){
          localStorage.setItem("xl","gsdt")
          this.$router.push({
            path:"/main/news"
          })
        }else if(num==2){
          localStorage.setItem("xl","m-service")
          this.$router.push({
            path:"/main/solutionAndServices"
          })
        }else if(num==3){
          localStorage.setItem("xl","classic-case")
          this.$router.push({
            path:"/main/classicCase"
          })
        }else if(num==5){
          localStorage.setItem("xl","secondaryMenu")
          this.$router.push({
            path:"/main/joinUs"
          })
        }else if(num==6){
          localStorage.setItem("xl","secondaryMenu")
          this.$router.push({
            path:"/main/aboutUs",
            query:{
              lx:true
            }
          })
        }
      }
    }
  };
</script>
<style lang="scss">
    .footer{
      width: 100%;
      min-width: 1200px;
      background-color: #323232;
    }

     .content{
       width: 1200px;
       margin: 0 auto;
       display: flex;
       justify-content: space-between;
       @media screen and (max-height:850px){
         .content-main{
           margin-top: 20px !important;
           margin-bottom: 10px !important;
           .content-main-bar{
             margin-bottom: 25px !important;
           }
           .city{
             margin-bottom: 10px !important;
           }
           .link-message{
             div{
               margin-bottom: 8px !important;
             }
           }
         }
       }
       .content-main{
         width: 80%;
         display: flex;
         align-items: center;
         flex-wrap: wrap;
         margin-right: 3%;
         margin-top: 48px;
         margin-bottom: 28px;
         .content-main-bar{
           width: 100%;
           display: flex;
           display: -webkit-box;
           display: -ms-flexbox;
           display: -webkit-flex;
           flex-wrap: wrap;
           margin-bottom: 50px;
           justify-content: space-between;
           -webkit-box-pack: justify;
           -ms-flex-pack: justify;
           -webkit-justify-content: space-between;
           span{
             min-width: 80px;
             color: #FFFFFF;
             font-size: 16px;
             cursor: pointer;
             font-weight: 800;
           }
         }

         .link-us{
           width: 100%;
           margin-bottom: 50px;
           span{
             color: #FFFFFF;
             font-size: 16px;
             margin-right: 30px;
           }
         }

         .city{
           width: 80%;
           display: flex;
           justify-content: space-between;
           margin-bottom: 18px;
           .city-name{
             .city_undeline{
               width:60px;
               height:2px;
               background-color: #FFFFFF;
               width: auto;
               margin-top: 12px;
             }
           }
           span{
             color: #FFFFFF;
             font-size: 16px;
             cursor: pointer;
           }
         }

         .link-message{
           div{
             margin-bottom: 15px;
           }
           span{
             color: #FFFFFF;
             font-size: 16px;
             margin-right: 60px;
           }
         }
       }
       .about-us{
         width: 120px;
         display: flex;
         flex-direction: column;
         justify-content: center;
         padding-top:4%;
         span{
           display: flex;
           justify-content: center;
           font-family: PingFangSC-Medium;
           font-size: 16px;
           color: #FFFFFF;
           letter-spacing: 0;
           margin-bottom: 20px;
         }
         /deep/.el-image{
           width: 120px;
         }
       }
     }


     .company{
       width: 100%;
       height: 47px;
       background-color: #242424;
       display: flex;
       align-items: center;
       justify-content: center;
       a{
         color: #FFFFFF;
         font-size: 16px;
         margin-right: 15px;
       }
       span{
         color: #FFFFFF;
         font-size: 16px;
       }
     }



</style>



// WEBPACK FOOTER //
// src/frame/main/ContentFooter.vue